<chr-icon name="download-alt" />
<chr-button
  *transloco="let t"
  size="s"
  palette="accent"
  variant="secondary"
  [label]="
    currentDownloadingFilesLength() === 0
      ? t('COMMON.FILE_MANAGER.FINISHED')
      : t('COMMON.FILE_MANAGER.DOWNLOADING', { counts: currentDownloadingFilesLength() })
  "
  (chr-action)="openFileExportManager()"
/>
